module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล","lastUpdateOilPrice":"อัพเดทล่าสุด","oilPrice":"ราคาน้ำมัน"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/share.json
// module id = 560
// module chunks = 69